import React from 'react';
import classnames from 'classnames';

import TrashIcon from 'hellospa/icons/trash';

class Signature extends React.PureComponent {

  onDeleteClick = (evt) => {
    evt.stopPropagation();

    this.props.onDelete(this.props.signature);
  };

  render() {
    return (
      <div className={
        classnames('signature-modal-saved__signature', {
          'signature-modal-saved__signature--selected': this.props.isSelected,
        })}
      >
        <div className="signature-modal-saved__signature-inner">
          <div
            className="signature-modal-saved__signature-image"
            style={{
              backgroundImage: `url(${this.props.signatureSrc})`,
            }} />
        </div>
        <div
          className="signature-modal-saved__signature-delete"
          onClick={this.onDeleteClick}
          data-qa-ref="signing-modal--delete"
        >
          <TrashIcon />
        </div>
      </div>
    );
  }
}

export default Signature;
